import { Router } from "aurelia-router";
import { autoinject, computedFrom } from "aurelia-framework";
import { applicationLogger } from "../logging/logger";
import { DialogService, DialogSettings } from "aurelia-dialog";
import { HttpClient } from "aurelia-fetch-client";
import { I18N } from "aurelia-i18n";
import { LocationApiProxy } from "../models/location-api-proxy";
import { SettingsDialog } from "../dialogs/settings-dialog";
import { LocationManagementDialog } from "../dialogs/location-management-dialog";
import {Location} from "../models/location"
import { IState } from "../store/state";
import { pluck } from 'rxjs/operators';
import { dispatchify, connectTo, Store } from 'aurelia-store';
import { clearLocalStorage } from "../store/actions/location-actions";

@connectTo<IState>({
	target: 'applicationState',
	selector: {
		//deviceRegistry: (store) => store.state.pipe(pluck('deviceRegistry')),
		applicationUser: (store) => store.state.pipe(pluck("applicationUser")),
		locationState: (store) => store.state.pipe(pluck("locationState"))
	}
})
@autoinject
export class Navmenu {
	i18n: I18N;
	httpClient: HttpClient;
	dialogService: DialogService;
	applicationState: IState;
	selectedLocation: Location;
	selectedLocations: Array<Location> = new Array<Location>();
	subscription: any;

	constructor( private store: Store<IState>, private router: Router, i18n: I18N, httpClient: HttpClient, dialogService: DialogService) {
		this.i18n = i18n;
		this.httpClient = httpClient;
		this.dialogService = dialogService;
		
	
	}

	bind() {
		this.selectedLocation = this.applicationState.locationState.locations.values[0];
		this.selectedLocations = this.applicationState.locationState.selectedLocations;
	
	}

	displaySettingsDialog() {
		this.dialogService.open({ viewModel: SettingsDialog, model: null, lock: false } as DialogSettings).whenClosed(response => {
			if (!response.wasCancelled) {
				applicationLogger.debug('good - ', response.output);
			} else {
				applicationLogger.debug('bad');
			}
			applicationLogger.debug(response.output);
		});
	}

	displayLocationsDialog() {
		this.dialogService.open({ viewModel: LocationManagementDialog, model: null, lock: false } as DialogSettings).whenClosed(response => {
			if (!response.wasCancelled) {
				applicationLogger.debug('good - ', response.output);
			} else {
				applicationLogger.debug('bad');
			}
			applicationLogger.debug(response.output);
		});
	}

	async logOut() {

		var httpClient = new HttpClient();
		httpClient.baseUrl = window.location.origin;
		await httpClient.post("/Account/Logout",
			{
				method: "post",
				body: JSON.stringify(""),
			}
		).then(response => {
			window.location.href = window.location.origin;
		});
	}

	async clearLocalStorage() {
		await this.store.dispatch(clearLocalStorage);
	}
}
